$(document).ready(function() {
  $('.newsletter-trigger').on('click', function(evt) {
    evt.preventDefault();
    $('#newsletter-modal').addClass('open');
    $('body').addClass('overflow-hidden');
    $('#navigation-modal').removeClass('open');
    return false;
  });

  $('.close-newsletter-modal').on('click', function(evt) {
    evt.preventDefault();
    $('#newsletter-modal').removeClass('open');
    $('body').removeClass('overflow-hidden');
    return false;
  })
});


